const pageNameKey = "timeIntervalInputAndDropDownWrapper";

export const timeIntervalInputAndDropDownWrapperEn = {
  [pageNameKey]: {
    secondsLabel: "Seconds",
    minutesLabel: "Minutes",
    hoursLabel: "Hours",
    daysLabel: "Days",
  },
};

export const timeIntervalInputAndDropDownWrapperPtBr = {
  [pageNameKey]: {
    secondsLabel: "Segundos",
    minutesLabel: "Minutos",
    hoursLabel: "Horas",
    daysLabel: "Dias",
  },
};

export const timeIntervalInputAndDropDownWrapperDe = {
  [pageNameKey]: {
    secondsLabel: "Sekunden",
    minutesLabel: "Minuten",
    hoursLabel: "Stunden",
    daysLabel: "Tage",
  },
};

export const timeIntervalInputAndDropDownWrapperZhHans = {
  [pageNameKey]: {
    secondsLabel: "秒",
    minutesLabel: "分钟",
    hoursLabel: "小时",
    daysLabel: "天",
  },
};

export const timeIntervalInputAndDropDownWrapperIt = {
  [pageNameKey]: {
    secondsLabel: "Secondi",
    minutesLabel: "Minuti",
    hoursLabel: "Ore",
    daysLabel: "Giorni",
  },
};

export const timeIntervalInputAndDropDownWrapperEs = {
  [pageNameKey]: {
    secondsLabel: "Segundos",
    minutesLabel: "Minutos",
    hoursLabel: "Horas",
    daysLabel: "Días",
  },
};

export const timeIntervalInputAndDropDownWrapperNl = {
  [pageNameKey]: {
    daysLabel: "Dagen",
    hoursLabel: "Uren",
    minutesLabel: "Minuten",
    secondsLabel: "Seconden",
  },
};

export const timeIntervalInputAndDropDownWrapperTr = {
  [pageNameKey]: {
    daysLabel: "Günler",
    hoursLabel: "Saat",
    minutesLabel: "dakika",
    secondsLabel: "Saniye",
  },
};
